// extracted by mini-css-extract-plugin
export default {"confettiImage":"style_confettiImage__O1VlR","buttonContainer":"style_buttonContainer__e0Qio","hult":"style_hult__zf2vo"};